import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class LinkType extends BaseOption {
  static LINK_TYPE_HYPERLINK = "hyperlink";
  static LINK_TYPE_PAGE = "page";
  static LINK_TYPE_STORY = "story";
  static LINK_TYPE_HASHTAG = "hashtag";

  static options = [
    {
      id: this.LINK_TYPE_HYPERLINK,
      name: "Hyperlink",
    },
    {
      id: this.LINK_TYPE_PAGE,
      name: "Page",
    },
    {
      id: this.LINK_TYPE_HASHTAG,
      name: "Hashtag",
    },
    {
      id: this.LINK_TYPE_STORY,
      name: "Story",
    },
  ];


  static userInterfaceComponent = {
    label: "Link Type",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      displayCaretIcon: true,
      options: this.options,
    },
  };

  static defaultValue = "hyperlink";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue;
  }
}
